import { useCallback, useEffect, useRef, useState } from 'react';

const useTimer = (options) => {
    const { initialValue = 0, step = 1000 } = options || {};

    const [time, setTime] = useState(initialValue);

    const timerInterval = useRef(null);

    useEffect(() => {
        return () => {
            clearInterval(timerInterval.current);
            timerInterval.current = null;
        };
    }, [timerInterval]);

    const start = useCallback(() => {
        if (!timerInterval.current) {
            timerInterval.current = setInterval(() => {
                setTime((preState) => preState + step);
            }, Math.abs(step));
        }
    }, [timerInterval, step]);

    const stop = useCallback(() => {
        setTime(0);
        clearInterval(timerInterval.current);
        timerInterval.current = null;
    }, [timerInterval]);

    const reset = useCallback(
        (resetValue) => {
            setTime(resetValue || initialValue);
            clearInterval(timerInterval.current);
            timerInterval.current = null;
        },
        [initialValue]
    );

    const pause = useCallback(() => {
        clearInterval(timerInterval.current);
        timerInterval.current = null;
    }, [timerInterval]);

    return {
        hours: Math.floor(time / 3600000),
        minutes: Math.floor(time / 60000) % 60,
        seconds: Math.floor((time / 1000) % 60),
        milliseconds: time,
        start,
        stop,
        pause,
        reset,
    };
};

export default useTimer;
